import { useRef } from "react";
import React from "react";
import ConfirmationPopup from "./ConfirmationPopup";
import cloud from "../../assets/img/fileupload.png";
import delimg from "../../assets/img/del.png";
function FileUpload(props) {
  const {
    files,
    setFiles,
    setError,
    error,
    showValidation,
    savedCompDocs,
    handleDeleteSaved,
  } = props;

  const [showConfirmationPopup, setShowConfirmationPopup] =
    React.useState(false);
  const [fileToDelete, setFileToDelete] = React.useState(null);

  const fileInputRef = useRef(null);
  const MAX_SIZE = 40 * 1024 * 1024;
  console.log("files", files);
  const ALLOWED_EXTENSIONS = ["pdf", "doc", "docx", "dwg"];
  const handleNameChange = (index, value) => {
    const updated = [...files];
    updated[index].docName = value;
    setFiles(updated);
  };
  const validation = (file) => {
    setError("");
    const selectedFiles = Array.from(file);

    // Check file extensions
    const invalidFile = selectedFiles.find((f) => {
      const ext = f.name.split(".").pop().toLowerCase();
      return !ALLOWED_EXTENSIONS.includes(ext);
    });

    if (invalidFile) {
      setError(
        `File type not allowed: ${invalidFile.name}. Only PDF, DOC, DOCX, DWG are accepted.`
      );
      return false;
    }
    const totalSize =
      files?.reduce((sum, f) => sum + f.file.size, 0) +
      selectedFiles.reduce((sum, f) => sum + f.size, 0);

    if (totalSize > MAX_SIZE) {
      setError("Total upload size must be less than 40 MB.");
      return false;
    }
    return true;
  };
  const handleFileChange = (event) => {
    const isFileValid = validation(event.target.files);
    if (isFileValid) {
      const newFiles = Array.from(event.target.files).map((file) => ({
        file,
        docName: file.name,
        type: "", // initial empty type
      }));
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
      console.log("newFiles", newFiles);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const isFileValid = validation(event.dataTransfer.files);
    if (isFileValid) {
      const droppedFiles = Array.from(event.dataTransfer.files).map((file) => ({
        file,
        docName: file.name,
        type: "",
      }));
      setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleBrowseClick = () => {
    fileInputRef.current.click();
  };

  const handleRemove = (indexToRemove) => {
    setFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== indexToRemove)
    );
  };

  const handleTypeChange = (index, newType) => {
    const updatedFiles = [...files];
    updatedFiles[index].type = newType;
    setFiles(updatedFiles);
  };

  const fileTypeOptions = ["Design", "Inspection", "Policy"];

  return (
    <div>
      <ConfirmationPopup
        show={showConfirmationPopup}
        headingText="Delete File"
        infoText="Are you sure you want to delete this file?"
        cancelText="Cancel"
        submitText="Delete"
        onCancel={() => {
          setShowConfirmationPopup(false);
        }}
        onSubmit={() => {
          setShowConfirmationPopup(false);
          handleDeleteSaved(fileToDelete);
        }}
      />
      <h5 className="text-start">Additional Document</h5>
      {savedCompDocs?.length > 0 &&
        savedCompDocs.map((fileObj) => (
          // eslint-disable-next-line react/jsx-key
          <div className="row  m-0">
            <div
              className=" mt-2 d-flex align-items-center justify-content-between p-3 my-2 gap-3"
              style={{
                border: "1px solid green",
                borderRadius: "8px",
                background: "#cef5ce",
              }}
            >
              <p className="mb-0">{fileObj?.complianceFileName}</p>

              <div className="form-floating w-25">
                <select
                  className={`form-select ${
                    showValidation && !fileObj.type ? "borderRed" : ""
                  }`}
                  id="floatingSelect"
                  aria-label="Floating label select example"
                  value={fileObj.complianceType}
                  disabled
                >
                  <option selected>Select Category</option>
                  {fileTypeOptions.map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
                <label htmlFor="floatingSelect">Select Category</label>
              </div>
              <div className="float-end">
                <i
                  className="fa-solid fa-xmark"
                  onClick={() => {
                    setFileToDelete(fileObj);
                    setShowConfirmationPopup(true);
                  }}
                ></i>
              </div>
            </div>
          </div>
        ))}

      <div
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        style={{
          border: "2px dashed gray",
          borderRadius: "10px",
          padding: "20px",
          textAlign: "center",
          marginBottom: "20px",
        }}
      >
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: "none" }}
          accept=".pdf, .doc, .docx, .dwg"
        />
        {error && (
          <p className="text-red-500 mt-2" style={{ color: "red" }}>
            {error}
          </p>
        )}
        {/* <button
          type="button"
          onClick={handleBrowseClick}
          style={{
            padding: "10px 20px",
            backgroundColor: "#4caf4f",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Browse Files
        </button> */}

        <img
          src={cloud} // replace with your image path
          alt="Browse Files"
          onClick={handleBrowseClick}
          style={{
            width: "290px", // adjust size as needed
            height: "auto",
            cursor: "pointer",
            borderRadius: "5px",
          }}
        />
      </div>
      {files.map((fileObj, index) => (
        // eslint-disable-next-line react/jsx-key
        <div className="row  m-0">
          <div
            className="col-sm-12 mt-2 d-flex align-items-center justify-content-between p-3 my-2 gap-3"
            style={{
              border: "1px solid green",
              borderRadius: "8px",
              background: "#F2F5FA",
            }}
          >
            <p className="mb-0 col-sm-4">{fileObj.file.name}</p>
            <input
              type="text"
              value={fileObj.docName}
              onChange={(e) => handleNameChange(index, e.target.value)}
              //   className="flex-1 border rounded p-2"
              className={`col-sm-4 border rounded p-2 min-w-40  ${
                showValidation && !fileObj.docName ? " borderRed" : ""
              }`}
              required
              placeholder="Enter File Name"
              style={{width:"250px"}}
            />
            <div className="form-floating  col-sm-4" >
              <select
                className={`form-select ${
                  showValidation && !fileObj.type ? "borderRed" : ""
                }` }   style={{height:"20px"}}
                id="floatingSelect"
                aria-label="Floating label select example"
                value={fileObj.type}
                onChange={(e) => handleTypeChange(index, e.target.value)}
             
              >
                <option selected>Choose Document Type</option>
                {fileTypeOptions.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
              {/* <label htmlFor="floatingSelect">
                Select Category<span style={{ color: "red" }}>*</span>
              </label> */}
            </div>
            <div className="float-end">
              {/* <i
                className="fa-solid fa-xmark"
                onClick={() => handleRemove(index)}
              ></i> */}
              <img
                src={delimg} // replace with your image path
                alt="Browse Files"
                onClick={() => handleRemove(index)}
                style={{
                  width: "20px", // adjust size as needed
                  height: "auto",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}
              />
            </div>
          </div>
        </div>
      ))}
      {/* File List */}
    
    </div>
    
  );
  
  
}

export default FileUpload;
